module.exports = __webpack_public_path__ + "media/34.c2aa0ebd.mp3";